import { API_URL } from "./graphqlRequest";

// Upload media files (video or image) to the server
export const uploadMedia = async (file: File, type: 'video' | 'image'): Promise<string | null> => {
  // Create the GraphQL query for upload
  const mutation = type === 'video' ? `
    mutation uploadVideo($video: Upload!, $videoType: String!) {
      uploadVideo(video: $video, videoType: $videoType) {
        success
        message
      }
    }
  ` : `
    mutation uploadImage($image: Upload!, $imageType: String!) {
      uploadImage(image: $image, imageType: $imageType) {
        success
        message
      }
    }
  `;

  // Create the operations map
  const operations = {
    query: mutation,
    variables: {
      [type === 'video' ? 'video' : 'image']: null,
      [type === 'video' ? 'videoType' : 'imageType']: type === 'video' ? 'exercise_video' : 'exercise_poster'
    }
  };

  // Create the file map
  const map = {
    [type === 'video' ? '0' : '0']: [`variables.${type === 'video' ? 'video' : 'image'}`]
  };

  const formData = new FormData();
  formData.append('operations', JSON.stringify(operations));
  formData.append('map', JSON.stringify(map));
  formData.append('0', file);
  const token = localStorage.getItem('authToken');

  try {
    const response = await fetch(API_URL, {
      method: 'POST',
      body: formData,
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    
    const result = await response.json();
    console.log('Upload API response:', result);
    
    if (result.data?.uploadVideo?.success || result.data?.uploadImage?.success) {
      // The response should contain the uploaded file URL
      const uploadResult = result.data?.uploadVideo || result.data?.uploadImage;
      console.log('Upload result:', uploadResult);
      const url = uploadResult?.message || uploadResult?.url || uploadResult?.publicUrl;
      console.log('Extracted URL:', url);
      
      // Check if the URL looks like a proper URL or just a filename
      if (url && !url.startsWith('http') && !url.startsWith('/')) {
        console.warn('Upload API returned filename instead of URL:', url);
        // If it's just a filename, we might need to construct the full URL
        // For now, return null to indicate upload failure
        return null;
      }
      
      return url;
    } else {
      const errorMessage = result.data?.uploadVideo?.message || result.data?.uploadImage?.message || 'Upload failed';
      throw new Error(errorMessage);
    }
  } catch (error) {
    console.error('Upload error:', error);
    throw error;
  }
}; 